import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/admin/AdminLogin.css'
import axios from 'axios'
import { io } from "socket.io-client";
import ToastNotification_Second from '../components/ToastNotification_Second';

const AdminLogin = ({adminData}) => {
  const navigate = useNavigate();
  const [adminId, setAdminId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const [companyId, setCompanyId] = useState("");
  const [branchCode, setBranchCode] = useState("");
  const [selectedRole, setSelectedRole] = useState('')
  const [employeeId, setEmployeeId] = useState('');
  const [employeeCode, setEmployeeCode] = useState('');
  const loginAttempt = useRef(0);
  const loginContext = useRef('');
  const [fetchCompany, setFetchCompany] = useState([])
  const [detail, setDetail] = useState([]);
   const [branches, setBranches] = useState([]);
   const [permissions, setPermissions] = useState({});
      const [notifications, setNotifications] = useState([]); 
      const [unreadCount, setUnreadCount] = useState(0); 
      const[year,setYear] = useState([]);  
   const [selectedYear, setSelectedYear] = useState('');

     const [secondToast, setSecondToast] = useState({
        show: false,
        message: '',
        bg: 'warning', 
      });
      
      const showSecondToast = (msg, bg = 'warning') => {
        setSecondToast({ show: true, message: msg, bg });
      };


  const [form, setForm] = useState({
    company_id: '',
    branch_id: '',
  })



loginContext.current = JSON.stringify([selectedRole, employeeId, employeeCode, form.company_id, form.branch_id]);

const handleInputChange = (e) => {
  const { name, value } = e.target;

  setForm((prev) => ({
    ...prev,
    [name]: value,
  }));

  if (name === "company_id") {
 
    const selectedBranches = detail.filter(
      (branch) => branch.company_id === parseInt(value)
    );
    setBranches(selectedBranches);


    setForm((prev) => ({ ...prev, branch_id: "" }));
  }
};



  const fecthCompanyDetail = async () => {
    try {
      const resDetail = await axios.get('https://api.skyguard.group/api/fetch-detail');

      setFetchCompany(resDetail.data.result);
    } catch (error) {
      console.log(error)
    }
  };


  const fecthDetail = async () => {
    try {
      const resBranch = await axios.get('https://api.skyguard.group/api/fetch-branch');

      setDetail(resBranch.data.result);
 
    } catch (error) {
      console.log(error)
    }
  };


  useEffect(() => {
    fecthDetail();
    fecthCompanyDetail();
    fetchYear();
  }, []);


const roleLabels = {
  admin: "Super Admin",
  employee: "Staff"
};


  const fetchYear = async () => {
    try {
      const res = await axios.get("https://api.skyguard.group/api/fetch-year-list");
      setYear(res.data);

    } catch (error) {
      console.error("Error fetching states:", error);
    }
  };



useEffect(() => {
  setPermissions({});
}, [employeeId, selectedRole, form.branch_id, form.company_id]);

const handleSubmit = async (e) => {
  e.preventDefault();
  const attempt = ++loginAttempt.current;
  const context = loginContext.current;
  if (selectedRole === 'employee') {
    setPermissions({});
    localStorage.removeItem('permissions');
    localStorage.removeItem('adminData');
  }

  try {
    if (!selectedRole) {
      setError("Please select a role");
      return;
    }

  
    // let payload = { role: selectedRole };
    let payload = {
  role: selectedRole,
  financial_year: selectedYear
};

    if (selectedRole === "admin") {
      if (!employeeId || !employeeCode) {
        setError("Please enter Employee ID and Employee Code for admin");
        return;
      }
      payload.emp_id = employeeId;
      payload.emp_code = employeeCode;

   

    }  else if (selectedRole === "employee") {
      if (!form.company_id || !form.branch_id || !employeeId || !employeeCode) {
        setError("Please fill all fields for Employee login");
        return;
      }
      payload.company_id = form.company_id;
      payload.branch_id = form.branch_id;
      payload.emp_id = employeeId;
      payload.emp_code = employeeCode;
    }

   
    const response = await axios.post("https://api.skyguard.group/api/admin-login", payload);
    if (attempt !== loginAttempt.current || context !== loginContext.current) return;

     if(response.status === 200){
  
        const separationDate = response.data?.user?.seperation_date;

   if ( separationDate &&
  separationDate !== '0000-00-00') {
  setError("This user does not exist");
  return;
}


        if (selectedRole === 'employee') {
          const permRes = await axios.get(
            'https://api.skyguard.group/api/user-permissions/' + response.data.user.id,
            { params: { branch_id: form.branch_id, employee_key: 'id' } }
          );
          if (attempt !== loginAttempt.current || context !== loginContext.current) return;
          const resolved = permRes.data.permissions;
          if (!resolved || typeof resolved !== 'object' || Array.isArray(resolved)) {
            throw new Error('Invalid branch permission response');
          }
          setPermissions(resolved);
          response.data.permissions = resolved;
        }

      const isSeperation = response.data.user.seperation_date
      if(isSeperation !== null ){
        setError("This user is not exist")
      }
   
    }

    if(selectedRole === 'admin' || selectedRole === 'employee'){
       localStorage.setItem("companyID", form.company_id);
        localStorage.setItem("branchID", form.branch_id );
    }
    localStorage.setItem("role", selectedRole);

    localStorage.setItem("adminData", JSON.stringify(response.data));
    
    localStorage.setItem(
  "financial_year",
  selectedYear
);

    setSuccess(`${roleLabels[selectedRole]} login successful!`);
    setError('');


  

const socket = io("https://api.skyguard.group/api");
socket.emit("register-user", employeeId);
window.userSocket = socket;



setTimeout(() => {
  navigate("/admin/dashboard");
}, 1000);
    setTimeout(() => {
      if (selectedRole === "admin") navigate("/admin/dashboard");
       else if (selectedRole === "employee") navigate("/admin/dashboard");
      else navigate("/admin/dashboard");
    }, 1000);


  } catch (error) {
    if (attempt !== loginAttempt.current || context !== loginContext.current) return;
    console.error("❌ Login Error:", error.response?.data || error.message);
    if (selectedRole === 'employee') {
      setPermissions({});
      localStorage.removeItem('permissions');
      localStorage.removeItem('adminData');
    }
    setError(error.response?.data?.message || error.message || "Invalid credentials");
    setSuccess('');
  }
};




  return (
    <div className="admin-login-container">
      <div className="login-box">
        <h2 className="p-4 fs-2 fw-bold">Welcome to Sky<span className='text-info'>Guard</span></h2>
        <h3>Admin Login</h3>


        <form onSubmit={handleSubmit} className="p-4 border rounded shadow-sm" style={{ maxWidth: 400, margin: "0 auto" }}>
      

             <div className="mb-3">

  <label className="form-label fw-bold">
    Select Year
  </label>

  <select
    className="form-select"
    value={selectedYear}
    onChange={(e) => setSelectedYear(e.target.value)}
  >

    <option value="">
      -- Select Financial Year --
    </option>

    {year.map((item) => (
      <option
        key={item.id}
        value={item.id}
      >
        {item.financial_year}
      </option>
    ))}

  </select>

</div>

          <div className="mb-3">
            <label className="form-label fw-bold">Select Role</label>
            <select
              className="form-select"
              value={selectedRole}
              onChange={(e) => setSelectedRole(e.target.value)}
              required
            >
              <option value="">Select Role </option>
              <option value="admin">Super Admin</option>
              <option value="employee">Staff</option>
            </select>
          </div>


          {selectedRole === "admin" && (
            <>
              <div className="mb-3">
                <select
                  className="form-control"
                  name="company_id"
                  value={form.company_id}
                  onChange={handleInputChange}
                >
                  <option value="">Select Company</option>

                  {fetchCompany.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-3">
                <select
  className="form-control"
  name="branch_id"
  value={form.branch_id}
  onChange={handleInputChange}
>
  <option value="">Select Branch</option>
  {branches.map((item) => (
    <option key={item.id} value={item.id}>
      {item.name}
    </option>
  ))}
</select>

              </div>

                <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Employee  ID"
                  value={employeeId}
                  onChange={(e) => setEmployeeId(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <input
                  type="password"
                  className="form-control"
                  placeholder="Password"
                  value={employeeCode}
                  onChange={(e) => setEmployeeCode(e.target.value)}
                  required
                />
              </div>
            </>
          )}


        

          {selectedRole === "employee" && (
            <>
               <div className="mb-3">
                <select
                  className="form-control"
                  name="company_id"
                  value={form.company_id}
                  onChange={handleInputChange}
                >
                  <option value="">Select Company</option>

                  {fetchCompany.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-3">
                <select
  className="form-control"
  name="branch_id"
  value={form.branch_id}
  onChange={handleInputChange}
>
  <option value="">Select Branch</option>
  {branches.map((item) => (
    <option key={item.id} value={item.id}>
      {item.name}
    </option>
  ))}
</select> 



              </div>

                <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Employee  ID"
                  value={employeeId}
                  onChange={(e) => setEmployeeId(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <input
                  type="password"
                  className="form-control"
                  placeholder="Password"
                  value={employeeCode}
                  onChange={(e) => setEmployeeCode(e.target.value)}
                  required
                />
              </div>

            </>
          )}



          <button type="submit" className="btn btn-primary w-100">
            Login
          </button>
        </form>

        {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
        {success && <p style={{ color: 'green', marginTop: '10px' }}>{success}</p>}
      </div>
    </div>
  );
};

export default AdminLogin;
